import $ from 'jquery';
import { dependency } from '../../utils/request';
import { frame } from '../../utils/drawing';
import { directiveSettings } from '../../utils/parse';

/**
 * The CDN directory of the Swiper library.
 *
 * @see http://idangero.us/swiper
 * @type {string}
 */
const swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.3.8/';

let addedCss = false;

/**
 * Initializes a Swiper carousel.
 *
 * @see http://idangero.us/swiper
 * @param context
 */
export default function swiperDirective(context=document.body) {
    const $context = $(context);
    const $swipers = $context.find('[sw-swiper]');

    if ($swipers.length > 0) {

        if (!addedCss) {
            addedCss = true;
            $('head').append(`<link rel="stylesheet" href="${swiperDir}css/swiper.min.css">`);
        }

        dependency(swiperDir + 'js/swiper.min.js', () => window.Swiper).then(function() {
            $swipers.each(function() {
                const $element = $(this);
                const json = $element.attr('sw-swiper');
                const settings = directiveSettings(json, {
                    loop: true,
                    preloadImages: false,
                    lazyLoading: true,
                    lazyLoadingInPrevNext: true,
                    paginationElement: 'button',
                    paginationClickable: true,
                    runCallbacksOnInit: true,
                });

                const $slides = $element.find('.swiper-slide');
                const swiper = $slides.length > 1 ? new Swiper(this, settings) : false;

                frame(() => $element.addClass('swiper-ready'));
            });
        });
    }
}



// WEBPACK FOOTER //
// ./source/scripts/directives/media/swiper.js